import { html } from 'lit';
import { ZoomIn } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-zoom-in')
export class PdsIconZoomIn extends PdsIcon {
  @state()
  icon = ZoomIn;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
